import { Component } from '@angular/core';

@Component({
  selector: 'app-quienes-somos',
  templateUrl: './quienes-somos.component.html',
  styleUrls: [
    '../../../assets/css/footer-pages.css',
    `./quienes-somos.component.css`,
  ],
})
export class QuienesSomosComponent {}
